import React from "react"
import PropTypes from "prop-types"
import L10n from "lib/carrot-l10n"
import DefaultMarkdown from "components/views/DefaultMarkdown"
import Wrapper from "components/views/Wrapper"
import Title from "../Title"
import { Spacer, FlexRowCenter } from "../atoms/Atoms"
import { IlloCircleMoneyBag } from "../atoms/Illustrations"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const Done = (props) => (
  <Wrapper medium>
    <div className="flex" id="submit-reimbursement-success">
      <div className="mw6 center">
        <Title title={props.carrotCard ? l`carrotCard.getYourCarrotCard` : l`Get reimbursed`} />
        <FlexRowCenter>
          <IlloCircleMoneyBag />
        </FlexRowCenter>
        <Spacer height={2} />
        <Spacer />
        {props.carrotCard ? (
          <DefaultMarkdown source={l`client.reimbursements.carrotCardSubmitSuccess`} />
        ) : (
          <DefaultMarkdown source={l`client.reimbursements.submitSuccess`} />
        )}
        <Spacer height={2} />
        <div className="flex flex-row justify-end">
          <ButtonPrimary to="/transactions">{l`carrotCard.request.gotIt`}</ButtonPrimary>
        </div>
      </div>
    </div>
  </Wrapper>
)

Done.propTypes = {
  onDone: PropTypes.func.isRequired
}

export default Done
